/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8.74406 2.5542C12.6297 8.18975 15.2331 14.4397 16.5454 20.9042M21.9755 12.8908C15.4276 11.4586 8.84406 14.0186 4.92951 19.0708M2.06166 10.9286C8.12849 11.572 14.4209 9.57752 19.071 4.92864"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19.071 19.071C22.9763 15.1658 22.9763 8.83414 19.071 4.92891C15.1657 1.02367 8.83386 1.02371 4.92851 4.92895C1.02316 8.83417 1.02416 15.1659 4.92951 19.0711C8.83483 22.9763 15.1656 22.9763 19.071 19.071Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M19.071 19.071C22.9763 15.1658 22.9763 8.83414 19.071 4.92891C15.1657 1.02367 8.83386 1.02371 4.92851 4.92895C1.02316 8.83417 1.02416 15.1659 4.92951 19.0711C8.83483 22.9763 15.1656 22.9763 19.071 19.071Z"
				fill="currentColor"
			/>
			<path
				d="M8.74405 2.55447C12.6297 8.19001 15.2331 14.44 16.5454 20.9044M21.9755 12.8911C15.4276 11.4589 8.84406 14.0189 4.92951 19.0711M4.92951 19.0711C8.83483 22.9763 15.1656 22.9763 19.071 19.071C22.9763 15.1658 22.9763 8.83414 19.071 4.92891M4.92951 19.0711C1.02416 15.1659 1.02316 8.83417 4.92851 4.92895C8.83386 1.02371 15.1657 1.02367 19.071 4.92891M2.06166 10.9289C8.12848 11.5722 14.4209 9.57779 19.071 4.92891"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.8268 2.09007C4.51549 3.4862 2.0499 6.49355 1.41206 10.1301C4.88406 10.452 8.41523 9.96623 11.7002 8.67048C10.5759 6.40933 9.28464 4.20989 7.8268 2.09007ZM1.25652 11.6221C1.25218 11.7475 1.25 11.8735 1.25 12C1.25 14.6899 2.23798 17.1491 3.87088 19.0345C6.35903 15.9648 9.72256 13.7384 13.473 12.6265C13.1226 11.7521 12.7485 10.885 12.3508 10.0261C8.81089 11.4409 4.99994 11.9718 1.25652 11.6221ZM4.93611 20.1035C6.82526 21.7517 9.29604 22.75 12 22.75C13.5101 22.75 14.9475 22.4386 16.2514 21.8766C15.7058 19.22 14.9597 16.5971 14.0134 14.0313C10.4552 15.0604 7.26723 17.1743 4.93611 20.1035ZM17.6334 21.1575C20.2459 19.547 22.1171 16.8497 22.617 13.696C20.1983 13.1986 17.7787 13.2134 15.4798 13.6732C16.3752 16.1242 17.0932 18.6254 17.6334 21.1575ZM22.7483 12.1924C22.7494 12.1284 22.75 12.0643 22.75 12C22.75 9.30735 21.76 6.84593 20.1242 4.95984C18.1977 6.84108 16.0316 8.32924 13.7257 9.42533C14.1572 10.3589 14.5617 11.3019 14.939 12.2532C17.4492 11.717 20.0977 11.6716 22.7483 12.1924ZM19.0651 3.8975C17.1758 2.24873 14.7045 1.25 12 1.25C11.0683 1.25 10.1644 1.36852 9.30231 1.5913C10.7175 3.68302 11.9762 5.84873 13.0779 8.07228C15.2353 7.04717 17.262 5.65582 19.0651 3.8975Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8.74405 2.55447C10.2385 4.72197 11.5433 6.98037 12.6579 9.30691M16.5454 20.9044C16.2102 19.2534 15.7909 17.6164 15.2874 16M21.9755 12.8911C19.3466 12.3161 16.712 12.3846 14.2466 12.9995M4.92951 19.0711C8.83483 22.9763 15.1656 22.9763 19.071 19.071C22.9763 15.1658 22.9763 8.83414 19.071 4.92891M4.92951 19.0711C1.02416 15.1659 1.02316 8.83417 4.92851 4.92895C8.83386 1.02371 15.1657 1.02367 19.071 4.92891M4.92951 19.0711C7.27243 16.0473 10.5714 13.9162 14.2466 12.9995M2.06166 10.9289C4.37618 11.1743 6.72353 11.0358 9 10.5125M19.071 4.92891C17.1661 6.8333 14.9856 8.29225 12.6579 9.30691M14.2466 12.9995C13.7689 11.7523 13.2393 10.5203 12.6579 9.30691"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8.74405 2.55447C12.6297 8.19001 15.2331 14.44 16.5454 20.9044M21.9755 12.8911C15.4276 11.4589 8.84406 14.0189 4.92951 19.0711M4.92951 19.0711C8.83483 22.9763 15.1656 22.9763 19.071 19.071C22.9763 15.1658 22.9763 8.83414 19.071 4.92891M4.92951 19.0711C1.02416 15.1659 1.02316 8.83417 4.92851 4.92895C8.83386 1.02371 15.1657 1.02367 19.071 4.92891M2.06166 10.9289C8.12848 11.5722 14.4209 9.57779 19.071 4.92891"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.31831 1.93681C8.65932 1.70169 9.12637 1.78753 9.3615 2.12854C10.7363 4.12244 11.9529 6.19216 13.0111 8.32047C15.0101 7.36219 16.8835 6.05504 18.5407 4.39831C18.8337 4.10545 19.3085 4.10552 19.6014 4.39845C19.8942 4.69138 19.8942 5.16626 19.6012 5.45911C17.8204 7.23951 15.8069 8.64398 13.6589 9.67351C14.0316 10.4827 14.3819 11.2997 14.7097 12.1235C17.0961 11.6221 19.6184 11.6076 22.1358 12.1582C22.5404 12.2467 22.7967 12.6465 22.7082 13.0512C22.6197 13.4558 22.2199 13.7121 21.8152 13.6236C19.5928 13.1375 17.366 13.1325 15.2506 13.5446C16.1082 15.904 16.7849 18.3145 17.2804 20.755C17.3628 21.161 17.1005 21.5568 16.6946 21.6392C16.2886 21.7216 15.8928 21.4594 15.8103 21.0534C15.3188 18.6318 14.6432 16.2407 13.7842 13.9018C10.5308 14.8569 7.62413 16.8177 5.52236 19.5303C5.26866 19.8577 4.79757 19.9175 4.47014 19.6638C4.14271 19.4101 4.08294 18.939 4.33664 18.6115C6.6071 15.6812 9.73744 13.5537 13.2438 12.4975C12.943 11.7503 12.6231 11.009 12.2841 10.2743C8.99574 11.5769 5.45286 12.0425 1.98256 11.6745C1.57065 11.6308 1.27215 11.2615 1.31583 10.8496C1.35951 10.4377 1.72883 10.1392 2.14073 10.1829C5.33887 10.522 8.60073 10.1013 11.6332 8.91846C10.6146 6.87786 9.44559 4.893 8.12659 2.98C7.89146 2.63899 7.9773 2.17194 8.31831 1.93681Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
